import { Card, CardBody, Col, Row } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { TopCountriesByActiveUsers } from "../../../../utils/Constant";
import ActiveUsers from "./ActiveUsers";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
    height: "300px",
  };
  
  const center = {
    lat: -3.745,
    lng: -38.523,
  };

const TopCountries = () => {
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey:
          "https://maps.googleapis.com/maps/api/js?key=AIzaSyBkNaAGLEVq0YLQMi-PYEMabFeREadYe1Q&v=3.exp&libraries=geometry,drawing,places",
    });
  return (
    <Col xl="7" className="col-xl-50">
      <Card className="countries-user">
        <CardHeaderCommon title={TopCountriesByActiveUsers} />
        <CardBody className="pt-0">
          <Row>
            <Col xxl="8" md="6" sm="7" className="col-xl-100">
              <div className="map">
                <div className="map-js-height">
                  <div id="gmap-simple" className="map-block">
                    {isLoaded ? (
                      <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={center}
                        zoom={10}
                      />
                    ) : (
                      "Loading"
                    )}
                  </div>
                </div>
              </div>
            </Col>
            <ActiveUsers />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TopCountries;
